import { createApiInstance } from './axios-config';
import { TopicCluster, ClusterSummary, SynthesisInsights } from '../../types/synthesis.types';

/**
 * Synthesis API Service
 *
 * Provides methods for Synthesis Mode topic clustering,
 * AI summary generation, and knowledge insights.
 */
class SynthesisApiService {
  private readonly baseUrl = '/api/v1/synthesis';
  private readonly axios = createApiInstance();

  /**
   * Cluster topics from the knowledge graph.
   */
  async clusterTopics(scope: string = 'personal'): Promise<TopicCluster[]> {
    const response = await this.axios.post(`${this.baseUrl}/cluster-topics`, { scope });
    return response.data.data.clusters;
  }

  /**
   * Generate an AI summary for a topic cluster.
   */
  async generateSummary(clusterName: string, topicUids: string[]): Promise<ClusterSummary> {
    const response = await this.axios.post(`${this.baseUrl}/generate-summary`, {
      clusterName,
      topicUids,
    });
    return response.data.data;
  }

  /**
   * Get knowledge graph insights.
   */
  async getInsights(scope: string = 'personal'): Promise<SynthesisInsights> {
    const response = await this.axios.get(`${this.baseUrl}/insights`, {
      params: { scope },
    });
    return response.data.data;
  }
}

export const synthesisApi = new SynthesisApiService();
